// Courses video sidenav

"use strict";

$(document).on('turbolinks:load', function() {
   var urlArray = window.location.pathname.split( '/' );
   var pagAtual =urlArray[urlArray.length -1];
   $("a.list-group-item[href*="+pagAtual+"]").addClass('active');
 });